var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuMarket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#905419;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,15.92V14.85H24.84L21.94,11a1,1,0,0,0,.3-.7,1,1,0,0,0-1-1,1,1,0,0,0-.72.31L14.88,8.26l0-1L13.93,5.9a1,1,0,0,0-.39-2,1.15,1.15,0,0,0-.41.08,1,1,0,0,0-.63,1,1,1,0,0,0,.66,1l-.93,1.36v.35L6.69,6.26a1,1,0,0,0-.94-.71,1,1,0,0,0-1,1,1,1,0,0,0,.3.71L2.17,11.06H1v1.07h.5c.56.91,2.25,1.56,4.24,1.56S9.44,13,10,12.13h.5V11.06H9.35L6.45,7.25l0,0,5.72,1.4-.41,11.74H9.58c-.73,0-1,.34-1,.78v.78a1,1,0,0,0-.91,1.19h11.8a1,1,0,0,0-.91-1.19v-.78c0-.44-.3-.78-1-.78H15.3L14.92,9.29l5.39,1.32a1,1,0,0,0,.24.42l-2.89,3.82H16.5v1.07H17c.56.9,2.25,1.56,4.24,1.56s3.69-.66,4.25-1.56H26ZM9,11.06H2.48L5.27,7.39a.91.91,0,0,0,1,0Zm11.73.11a.91.91,0,0,0,.49.15.88.88,0,0,0,.48-.15l2.8,3.68H18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMarket);
export default __webpack_public_path__ + "static/media/menu_market.51823be5.svg";
export { ForwardRef as ReactComponent };